'use strict';

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactMixin = require('react-mixin');

var _reactMixin2 = _interopRequireDefault(_reactMixin);

var _InputGroup = require('./InputGroup');

var _InputGroup2 = _interopRequireDefault(_InputGroup);

var _Input = require('./Input');

var _Input2 = _interopRequireDefault(_Input);

var _Select = require('./Select');

var _Select2 = _interopRequireDefault(_Select);

var _mixin = require('../mixin');

var _mixin2 = _interopRequireDefault(_mixin);

var DAY_TOKEN = 'd',
    MONTH_TOKEN = 'M',
    YEAR_TOKEN = 'y';

var ERRORS = {
    INCOMPLETE: 0,
    INVALID_DATE: 1,
    MIN_DATE: 2,
    MAX_DATE: 3
};

var DateInput = (function (_React$Component) {
    _inherits(DateInput, _React$Component);

    function DateInput(props) {
        _classCallCheck(this, DateInput);

        _get(Object.getPrototypeOf(DateInput.prototype), 'constructor', this).call(this, props);
        this.state = {
            focused: false
        };
    }

    _createClass(DateInput, [{
        key: 'buildDateComponent',
        value: function buildDateComponent() {
            var _this = this;

            var getComponentProps = function getComponentProps(key) {
                return _extends({}, _this.props.layout.properties[key], { // placeholder, label, and any additional props
                    disabled: _this.props.disabled,
                    errors: !_this.state.focused && _this.props.errors.length > 0 ? [''] : [], // TODO: better way of making input components red?
                    onBlur: _this.onFieldBlur.bind(_this),
                    onChange: _this.onFieldChange.bind(_this, key),
                    onFocus: _this.onFieldFocus.bind(_this),
                    readOnly: _this.props.readOnly,
                    showErrorIcon: false,
                    value: !isNaN(parseInt(_this.props.date[key])) ? _this.props.date[key] : '',
                    id: _this.props.id ? _this.props.id + '-' + key : null,
                    name: key,
                    key: key
                });
            };
            return this.props.layout.layout.map(function (pattern) {
                var token = pattern.charAt(0);
                var InputComponent = _Input2['default'],
                    props;
                switch (token) {
                    case DAY_TOKEN:
                        props = _extends({}, getComponentProps('day'), {
                            type: 'number',
                            min: 1,
                            max: 31,
                            pattern: '\d*'
                        });
                        props.value = _this.getDayValue(pattern);
                        break;
                    case MONTH_TOKEN:
                        InputComponent = _Select2['default'];
                        props = _extends({}, getComponentProps('month'), {
                            options: _this.getMonthOptions(pattern)
                        });
                        break;
                    case YEAR_TOKEN:
                        props = _extends({}, getComponentProps('year'), {
                            type: 'number',
                            pattern: '\d*'
                        });
                        break;
                }
                return _react2['default'].createElement(InputComponent, props);
            });
        }
    }, {
        key: 'getDayValue',
        value: function getDayValue(pattern) {
            // pattern is 'd' or 'dd'
            var val = parseInt(this.props.date.day, 10); // date.day is either an int or null
            if (pattern.length === 2 && !isNaN(val)) {
                // add or remove leading zero if pattern is 'dd'
                if (val === 0) {
                    val = '';
                } else if (val < 10) {
                    val = '0' + val;
                }
                return val.toString();
            }
            return val || ''; // return either int or empty string if null
        }
    }, {
        key: 'getMonthOptions',
        value: function getMonthOptions(pattern) {
            var months;
            if (pattern.length === 4) {
                // MMMM -> January ... December
                months = this.props.localeLabels != null ? this.props.localeLabels.month : this.generateMonths('long');
            } else if (pattern.length === 3) {
                // MMM -> Jan ... Dec
                months = this.props.localeLabels != null ? this.props.localeLabels.shortMonth : this.generateMonths('short');
            } else if (pattern.length === 2) {
                // MM -> 01 ... 12
                months = this.generateMonths('2-digit');
            } else if (pattern.length === 1) {
                // M -> 1 ... 12
                months = this.generateMonths('narrow');
            }
            return months.map(function (month, i) {
                return {
                    label: month,
                    value: i
                };
            });
        }
    }, {
        key: 'generateMonths',
        value: function generateMonths(representation) {
            // representation is 'long', 'short', '2-digit', or 'narrow'
            // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/DateTimeFormat
            var intlFormatter = new Intl.DateTimeFormat(this.props.locale, { month: representation });
            return Array.from(Array(12)).map(function (x, i) {
                return intlFormatter.format(new Date(2018, i));
            });
        }
    }, {
        key: 'onFieldChange',
        value: function onFieldChange(field, value) {
            var date = this.cloneObject(this.props.date);
            // don't allow input of days that are invalid or years in the far future
            if (field === 'year' && value.length > 4 || field === 'day' && value.length > 2) {
                return;
            }
            var val = parseInt(value, 10);
            date[field] = !isNaN(val) ? val : null;
            if (this.props.onChange) {
                var errors = this.validate(date);
                this.props.onChange(date, errors);
            }
        }
    }, {
        key: 'onFieldFocus',
        value: function onFieldFocus() {
            // called when any field fires onFocus
            this.setState({ focused: true });
        }
    }, {
        key: 'onFieldBlur',
        value: function onFieldBlur() {
            var _this2 = this;

            // called when any field fires onBlur
            this.setState({ focused: false });
            window.setTimeout(function () {
                // determine if focus switched to another field
                if (!_this2.state.focused) {
                    _this2.onWholeComponentBlur();
                }
            }, 0);
        }
    }, {
        key: 'onWholeComponentBlur',
        value: function onWholeComponentBlur() {
            // called when focus leaves the DateInput fields
            if (this.props.onBlur) {
                this.props.onBlur();
            }
        }
    }, {
        key: 'validate',
        value: function validate(dateObj) {
            // returns array of ints from ERRORS enum defined at the top
            var errors = [];
            var date = new Date(dateObj.year, dateObj.month, dateObj.day);
            if (dateObj.day === null && dateObj.month === null && dateObj.year === null) {
                return errors; // all fields blank
            } else if (!(dateObj.day !== null && dateObj.month !== null && dateObj.year !== null)) {
                    errors.push(ERRORS.INCOMPLETE); // one or two fields blank
                } else if (dateObj.month !== date.getMonth()) {
                        // https://stackoverflow.com/questions/5812220/how-to-validate-a-date
                        errors.push(ERRORS.INVALID_DATE);
                    } else if (this.props.minDate instanceof Date && this.props.minDate > date) {
                        errors.push(ERRORS.MIN_DATE);
                    } else if (this.props.maxDate instanceof Date && this.props.maxDate < date) {
                        errors.push(ERRORS.MAX_DATE);
                    }
            if (this.props.validate) {
                Array.prototype.push.apply(errors, this.props.validate(dateObj));
            }
            return errors;
        }
    }, {
        key: 'getNotifications',
        value: function getNotifications() {
            var list = function list(item, index) {
                return _react2['default'].createElement(
                    'li',
                    { key: index },
                    item
                );
            };
            if (this.props.help && this.props.help.length > 0) {
                return _react2['default'].createElement(
                    'div',
                    { key: 'help', className: 'Input-info' },
                    _react2['default'].createElement(
                        'ul',
                        null,
                        this.props.help.map(list)
                    )
                );
            } else if (!this.state.focused && this.props.errors.length > 0) {
                return _react2['default'].createElement(
                    'div',
                    { key: 'error', className: 'Input-error' },
                    _react2['default'].createElement(
                        'ul',
                        null,
                        this.props.errors.map(list)
                    )
                );
            } else if (this.props.info && this.props.info.length > 0) {
                return _react2['default'].createElement(
                    'div',
                    { key: 'info', className: ' Input-info' },
                    _react2['default'].createElement(
                        'ul',
                        null,
                        this.props.info.map(list)
                    )
                );
            }
        }
    }, {
        key: 'render',
        value: function render() {
            return _react2['default'].createElement(
                _InputGroup2['default'],
                {
                    id: this.props.id,
                    label: this.props.label,
                    className: 'DateInput',
                    error: this.props.errors.length > 0,
                    contiguous: true },
                _react2['default'].createElement(
                    _InputGroup2['default'].Section,
                    null,
                    this.buildDateComponent()
                ),
                this.getNotifications()
            );
        }
    }]);

    return DateInput;
})(_react2['default'].Component);

DateInput.propTypes = {
    date: _propTypes2['default'].shape({
        day: _propTypes2['default'].number,
        month: _propTypes2['default'].number, // 0-based
        year: _propTypes2['default'].number
    }),
    disabled: _propTypes2['default'].bool,
    errors: _propTypes2['default'].arrayOf(_propTypes2['default'].string),
    help: _propTypes2['default'].arrayOf(_propTypes2['default'].string),
    id: _propTypes2['default'].string,
    info: _propTypes2['default'].arrayOf(_propTypes2['default'].string),
    label: _propTypes2['default'].string,
    layout: _propTypes2['default'].shape({
        // layout pattern strings described in table here:
        // https://github.paypal.com/Globalization-Playground/griffin-client-date-time-design#mapping-from-patterns-to-masks
        layout: _propTypes2['default'].arrayOf(_propTypes2['default'].oneOf(['d', 'dd', 'M', 'MM', 'MMM', 'MMMM', 'yyyy'])),
        properties: _propTypes2['default'].shape({
            day: _propTypes2['default'].shape({
                label: _propTypes2['default'].string,
                placeholder: _propTypes2['default'].string
            }),
            month: _propTypes2['default'].shape({
                label: _propTypes2['default'].string,
                placeholder: _propTypes2['default'].string
            }),
            year: _propTypes2['default'].shape({
                label: _propTypes2['default'].string,
                placeholder: _propTypes2['default'].string
            })
        })
    }),
    locale: _propTypes2['default'].string,
    localeLabels: _propTypes2['default'].shape({
        shortMonth: _propTypes2['default'].arrayOf(_propTypes2['default'].string),
        month: _propTypes2['default'].arrayOf(_propTypes2['default'].string)
    }),
    maxDate: _propTypes2['default'].instanceOf(Date), // TODO: validate that maxDate >= minDate
    minDate: _propTypes2['default'].instanceOf(Date),
    onBlur: _propTypes2['default'].func,
    onChange: _propTypes2['default'].func,
    onFocus: _propTypes2['default'].func,
    readOnly: _propTypes2['default'].bool,
    validate: _propTypes2['default'].func
};

DateInput.defaultProps = {
    date: {
        day: null,
        month: null,
        year: null
    },
    disabled: false,
    errors: [],
    layout: {
        layout: ['MMMM', 'd', 'yyyy'],
        properties: {
            day: {
                label: 'Day',
                placeholder: 'dd'
            },
            month: {
                label: 'Month',
                placeholder: 'Month'
            },
            year: {
                label: 'Year',
                placeholder: 'yyyy'
            }
        }
    },
    readOnly: false
};

(0, _reactMixin2['default'])(DateInput.prototype, _mixin2['default']);

module.exports = DateInput;


//////////////////
// WEBPACK FOOTER
// /causemisspiggynodeweb-ci-9188/workspace/Release/~/kepler/lib/components/DateInput.js
// module id = 283
// module chunks = 0